import {
  Button,
  Card,
  Input,
  // Modal,
  Tag,
  Tooltip
} from 'antd'
import React from 'react'
import { useHistory } from 'react-router'
import { useTheme } from 'styled-components'
// Local Files
import HeaderLayout from '../../../layouts/HeaderLayout'
import Candidates from '../SearchCandidate'
import {
  InputContainer,
  SavedSearchLinkContainer,
  SearchContainer,
  TagsContainer,
  ViewSavedSearchLink
} from './style'
// Context
import {
  setSearchApiObj,
  setSearchBarValue,
  useQueryActions,
  useQuerysDispatch,
  useQuerysState
} from '../CandidateContext/SearchQueryContext'

export default function SearchBar() {
  const [searchBarField, setSearchBarField] = React.useState({
    title: '',
    skills: []
  })
  const theme = useTheme()
  const history = useHistory()
  const dispatch = useQuerysDispatch()
  const action = useQueryActions()
  const { searchBarValues, searchApiObj } = useQuerysState()
  const [savedSearch, setSavedSearch] = React.useState(false)
  // const [remoteVal, setRemoteVal] = React.useState(false)
  const [tagsVal, setTagsVal] = React.useState([])
  const [skillsInputVal, setSkillsInputVal] = React.useState('')
  const [hoverState, setHoverState] = React.useState(false)

  const handleKeyDown = (e) => {
    const lastChar = skillsInputVal.trim().slice(-1)

    if (e.key === ' ' && [',', ';'].includes(lastChar)) {
      e.preventDefault()

      const skill = skillsInputVal.trim().slice(0, -1).trim()
      if (!skill) return

      const arr = [...tagsVal, skill]
      setTagsVal(arr)

      dispatch(
        setSearchApiObj({
          ...searchApiObj,
          shouldHave: { ...searchApiObj.shouldHave, expertise: arr }
        })
      )

      dispatch(setSearchBarValue({ ...searchBarValues, skills: arr }))
      setSearchBarField({ ...searchBarField, skills: arr })
      setSkillsInputVal('')
    } else if (e.key === 'Backspace' && tagsVal.length !== 0 && skillsInputVal === '') {
      const arr = [...tagsVal]
      arr.pop()
      dispatch(
        setSearchApiObj({
          ...searchApiObj,
          shouldHave: { ...searchApiObj.shouldHave, expertise: [...arr] }
        })
      )
      dispatch(setSearchBarValue({ ...searchBarValues, skills: arr }))
      setSearchBarField({ ...searchBarField, skills: arr })
      setTagsVal([...arr])
    }
  }
  const handleChange = (e) => {
    const { name, value } = e.target

    if (name === 'title') {
      dispatch(
        setSearchApiObj({
          ...searchApiObj,
          shouldHave: { ...searchApiObj.shouldHave, current_title: [value] }
        })
      )
      dispatch(setSearchBarValue({ ...searchBarValues, [name]: value }))
      setSearchBarField({ ...searchBarField, [name]: value })
    } else if (name === 'skills') {
      setSkillsInputVal(value)
    }
  }

  const handleSearch = () => {
    try {
      action.getCandidatesFromSearch({ annotations: searchApiObj })
    } catch (e) {
      console.log(e)
    } finally {
      const { title, skills } = searchBarValues
      const string = skills.join(',')
      history.push(
        `/simplesearch/${encodeURIComponent(title) || 'no_title'}/${encodeURIComponent(string)}`
      )
    }
  }
  const tooltipStyle = {
    display: 'flex',
    alignItems: 'center',
    height: '26px',
    width: '76px',
    objectFit: 'contain',
    borderRadius: '3px',
    border: 'solid 1px #d9d9d9',
    backgroundColor: '#f5f5f5',
    color: '#000',
    marginBottom: '5px',
    paddingLeft: '5px'
  }
  const tooltipEllipsis = {
    whiteSpace: ' nowrap',
    overflow: ' hidden',
    textOverflow: ' ellipsis'
  }

  const disableButtonConditionArray = Object.values(searchBarField)

  return (
    <HeaderLayout title="Search Passive Candidates">
      <Card style={{ height: 'calc(100vh - 200px)' }}>
        <SearchContainer>
          <div>
            <img src={theme.logo || 'https://score.ai4jobs.info/logo.png'} />
          </div>
          <div>
            <Input
              name="title"
              className="title-input"
              placeholder="Search by Job Title"
              onChange={(e) => handleChange(e)}
              allowClear
            />
          </div>
          {/* <div className='remote-switch'> */}
          {/*  <div>Remote:</div> */}
          {/*  <div><Switch checked={remoteVal} onChange={() => { setRemoteVal(!remoteVal) }}/></div> */}
          {/* </div> */}
          <div className="input-container">
            <InputContainer>
              <TagsContainer className="tags-wrappers">
                {tagsVal.length !== 0 &&
                  tagsVal
                    .filter((item, index) => index < 5)
                    .map((ele, ind) =>
                      ele.length > 7 ? (
                        <Tooltip key={ind} title={ele}>
                          <Tag key={ind}>
                            <div className="tags-ellipsis">{ele}</div>
                          </Tag>
                        </Tooltip>
                      ) : (
                        <Tag key={ind}>
                          <div className="tags-ellipsis">{ele}</div>
                        </Tag>
                      )
                    )}
                {tagsVal.length !== 0 && tagsVal.length > 5 && (
                  <Tag
                    onMouseOver={() => setHoverState(true)}
                    onMouseLeave={() => setHoverState(false)}
                    className="more-tag"
                  >
                    {hoverState ? (
                      <Tooltip
                        overlayInnerStyle={{
                          width: '95px',
                          display: 'flex',
                          justifyContent: 'center',
                          flexWrap: 'wrap'
                        }}
                        placement="bottomLeft"
                        title={tagsVal
                          .filter((item, index) => index > 0)
                          .map((ele, ind) => (
                            <div style={tooltipStyle} key={ind}>
                              <div name={ele} style={tooltipEllipsis}>
                                {ele}
                              </div>
                            </div>
                          ))}
                      >
                        <div>{`+${tagsVal.length - 1} more`}</div>
                      </Tooltip>
                    ) : (
                      <div>{`+${tagsVal.length - 1} more`}</div>
                    )}
                  </Tag>
                )}
              </TagsContainer>
              <Input
                type="text"
                value={skillsInputVal}
                name="skills"
                onChange={(e) => handleChange(e)}
                className="other-input"
                placeholder="Add 4 or more skills"
                onKeyDown={(e) => handleKeyDown(e)}
                // value={searchBarValues.skills === 'no_skills' ? '' : searchBarValues.skills}
                allowClear
              />
            </InputContainer>
            {/* <Input
              type="text"
              name="location"
              onChange={(e) => handleChange(e)}
              className="other-input"
              placeholder="Add location if not remote"
              allowClear
              value={searchBarValues.location === "no_location" ? "" : searchBarValues.location}
              // disabled={remoteVal}
            /> */}
          </div>
          <div className={'tags-helper'}>
            <span style={{ marginRight: '76px' }}>
              Separate skills by <b>&apos;, &apos;</b> and <b>&apos;; &apos;</b>
            </span>
            {/* <span>{'Use "City, State" (2 Letter Format)'}</span> */}
          </div>
          <div>
            <Button
              onClick={() => handleSearch()}
              className="search-button"
              type="primary"
              disabled={!disableButtonConditionArray[0] || !disableButtonConditionArray[1]?.length}
            >
              Search Candidates
            </Button>
          </div>
          <SavedSearchLinkContainer>
            <ViewSavedSearchLink onClick={() => setSavedSearch(true)}>
              View Saved Searches
            </ViewSavedSearchLink>
          </SavedSearchLinkContainer>
        </SearchContainer>
        <Candidates setSavedSearch={setSavedSearch} savedSearch={savedSearch} />
      </Card>
    </HeaderLayout>
  )
}
